import type { GameState, TileState } from '../types';
import { ROWS } from '../game/constants';
import { MAX_SCORE, gradeForScore, totalScore } from '../game/killerNotes';
import { showToast } from './toast';

const TILE_GLYPH: Record<TileState, string> = {
  correct: '🟩',
  present: '🟧',
  absent: '⬛',
};

export function buildShareString(state: GameState): string {
  const lines = state.guesses.map((g) => g.results.map((r) => TILE_GLYPH[r]).join(''));
  const won = state.status === 'won';
  const result = won ? `🌅 ${state.guesses.length}/${ROWS}` : `🔪 X/${ROWS}`;
  const grade = gradeForScore(totalScore(state), won);
  const scoreFragment = state.chillMode
    ? 'CHILL MODE'
    : `${totalScore(state)}/${MAX_SCORE} • ${grade}`;
  const scoreLine = `${result} • ${scoreFragment}`;
  return `TAPE TRAP #${state.puzzle.dayIndex} — ${state.puzzle.movie.name}\n${scoreLine}\n\n${lines.join('\n')}\n\n📼 tapetrap.com`;
}

export async function shareOrCopy(text: string): Promise<void> {
  if (navigator.share) {
    try {
      await navigator.share({ text });
      return;
    } catch {
      // User cancelled or share failed — fall back to clipboard.
    }
  }
  try {
    await navigator.clipboard.writeText(text);
    showToast('Copied to clipboard');
  } catch {
    showToast('Could not copy');
  }
}
